import Card from 'scripts/models/api/cards/base/card';
import Image from 'scripts/models/api/image/image';
import can from 'can'

export default Card.extend({
    define: {
        title: {
            type: 'string',
            value: ''
        },
        image: Image,
    }
});
